module.exports = __webpack_public_path__ + "static/media/more_lined.23b1c458.svg";